import styled from "styled-components";

export const GamesOpenSessionDateContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      font-size: ${props => props.theme.font.size.xSmall};
  }
  
`
